import React from 'react'
import { useEffect } from 'react'

export default props => {
    const { money,locale } = props
    const dataLocale=locale?locale:"en_GB"

    useEffect(() => {
        let afterpayScript = document.getElementById('afterpay-message-script')
        const head = document.getElementsByTagName('head')[0]
        if (!afterpayScript) {
            const script = document.createElement('script')
            script.id = 'afterpay-message-script'
            script.type = 'text/javascript'
            script.src = `https://js.afterpay.com/afterpay-1.x.js`
            script.async = true
            head.appendChild(script)
        }
    }, [])

    return <afterpay-placement
        data-locale={dataLocale}
        data-currency={money?.currency}
        data-size="xs"
        data-amount={money?.amount}>
    </afterpay-placement>

}